import { Button, CircularProgress } from '@mui/joy';
import React, { Dispatch, SetStateAction } from 'react';
import { AgGridReact } from "ag-grid-react"; // React Data Grid Component
import { ColDef } from "ag-grid-community";

type Matrice = {
    id: number;
    matrice_name: string;
    backend_matrice_name: string;
    toggle: boolean;
    position: number;
  };

type ViewProps = {
    view_type: string;
    viewHeaderName: string;
    subHeaderName: string;
    performerArr: {frontend_name: string, backend_name: string}[];
    stage_3: string[];
    performer: string;
    product_detail: string;
    setProduct_detail: Dispatch<SetStateAction<string>>;
    setPerformer: Dispatch<SetStateAction<string>>;
    setMetricsToggle: Dispatch<SetStateAction<boolean>>;
    onChangeStageHandler: (ag_view: string, ag_performer: string, ag_productDetail: string, ag_metrics: Matrice[]) => void;
    metrics: Matrice[];
    section2ColDefs: ColDef<any>[];
    section2Data: any[];
    loading: boolean;
    section2width: Number;
    saveLastState: (ag_view: string, ag_performer: string, ag_productDetail: string, ag_metrics: Matrice[]) => void;
}

// View Component for Product, Campaign, Targeting, CST
const ViewComponent1: React.FC<ViewProps> = ({
    view_type,
    viewHeaderName, 
    subHeaderName,
    performerArr, 
    stage_3,
    performer,
    product_detail,
    setProduct_detail,
    setPerformer,
    setMetricsToggle,
    onChangeStageHandler,
    metrics,
    section2ColDefs,
    section2Data,
    loading,
    section2width,
    saveLastState
}) => {
    return (
    <>
        <div className="w-full mb-[24px]" >
            <div
                className="self-stretch"
                style={{
                color: "var(--Text-Primary-Black, #1C1C1E)",
                fontFamily: "Inter",
                fontSize: "20px",
                fontStyle: "normal",
                fontWeight: 700,
                lineHeight: "26px",
                }}
            >
                {viewHeaderName}
                {/* Top and Bottom Performers by Gross Sales Difference */}
            </div>
        </div>

        <div
            className="flex"
            style={{
            zIndex: 10
            }}
        >
            {performerArr?.map((p) => (
                <div className="w-[200px]"
                style={{
                    display:  "flex",
                    // padding: "0px 16px",
                    justifyContent: "center",
                    alignItems: "center",
                    alignSelf: "stretch",
                    cursor: "pointer",
                    boxShadow:
                    performer === p?.backend_name
                        ? "0px 4px 16px 16px rgba(130,130,130,0.05)" : "",
                    borderTopLeftRadius: 
                    performer === p?.backend_name
                    ? "8px"
                    : "0px",
                    borderTopRightRadius: 
                    performer === p?.backend_name
                    ? "8px"
                    : "0px",
                }}
                key={p?.backend_name}
                onClick={() => {
                    if(view_type === "product"){
                        setProduct_detail('CATEGORIES');
                        onChangeStageHandler(view_type, p?.backend_name, 'CATEGORIES', metrics);
                        saveLastState(view_type, p?.backend_name, 'CATEGORIES', metrics);
                    }
                    if(view_type === "campaign" || view_type === "targeting" || view_type === "cst"){
                        setProduct_detail('BY SALES');
                        onChangeStageHandler(view_type, p?.backend_name, 'BY SALES', metrics);
                        saveLastState(view_type, p?.backend_name, 'BY SALES', metrics);
                    }
                    setPerformer(p?.backend_name);
                }}
                >
                <div
                    style={{
                    color:
                        performer === p?.backend_name
                        ? "#1565C0"
                        : "var(--Text-Primary-Grey, #97979A)",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "12px",
                    fontStyle: "normal",
                    padding: "16px 0px",
                    // height: "100%",
                    fontWeight: performer === p?.backend_name ? 600 : 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center"
                    }}
                >
                    {`${p?.frontend_name}`}
                </div>
                </div>
            ))}
        </div>

        {performer === "TOP" ? (
            <div className="w-full p-2" style={{
                boxShadow: "0px 4px 16px 16px rgba(130,130,130,0.05)",
                borderEndStartRadius: "8px",
                borderEndEndRadius: "8px",
                borderTopRightRadius: "8px",
                zIndex: 20
            }}>
            <div
                className="flex h-[40px] px-[6px] py-1 w-fit mb-2 items-start rounded-[4px]"
                style={{
                backgroundColor: "#F9F9FB",
                }}
            >
                {stage_3?.map(name => {
                    return (
                        <div
                className="flex w-[150px] px-4 py-2 justify-center items-center gap-1 self-stretch rounded-[4px] cursor-pointer"
                style={{
                    color: product_detail === name
                    ? "#FFF"
                    : "#97979A",
                    backgroundColor: product_detail === name
                    ? "#1565C0"
                    : "#F9F9FB",
                    boxShadow: product_detail === name
                    ? "0px 4px 16px 16px rgba(130,130,130,0.05)"
                    : "none",
                }}
                onClick={() => {
                    setProduct_detail(name);
                    onChangeStageHandler(view_type, performer, name, metrics);
                    saveLastState(view_type, performer, name, metrics);
                }}
                >
                <div
                    style={{
                    color: product_detail === name
                        ? "white"
                        : "#97979A",
                    textAlign: "center",
                    fontFamily: "Inter",
                    fontSize: "10px",
                    fontStyle: "normal",
                    fontWeight: product_detail === name
                        ? 600
                        : 500,
                    lineHeight: "10px",
                    letterSpacing: "1.6px",
                    textTransform: "uppercase",
                    }}
                >
                    {name}
                </div>
                </div>)
                })}

            </div>

            <div className="flex flex-col h-[236px] gap-4">
                <div className="flex justify-between items-start gap-4 self-stretch">
                    <div className="flex flex-col justify-center items-start gap-1">
                        <div
                        className="self-stretch"
                        style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "26px",
                            textTransform: "uppercase"
                        }}
                        >
                        {subHeaderName}
                        {/* Top 5 {product_detail} by Highest Gross Sales Difference */}
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <Button
                        color="neutral"
                        sx={{
                            height: 32,
                            width: 80,
                            fontSize: 14,
                            fontWeight: 700,
                            backgroundColor: "#FFF",
                            lineHeight: "20px",
                            color: "#1C1C1E",
                            ":hover": {
                            backgroundColor: "#FFF",
                            },
                            paddingX: "6px",
                            paddingY: 0,
                            gap: "8px",
                            borderRadius: "6px",
                            border: `1px solid #EAEAED`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                        }}
                        onClick={() => {
                            setMetricsToggle(true);
                        }}
                        >
                        <div
                            style={{
                            fontSize: "12px",
                            fontWeight: "700",
                            textAlign: "center",
                            lineHeight: "18px",
                            color: "#1C1C1E",
                            }}
                        >
                            Metrics
                        </div>
                        </Button>
                    </div>
                </div>

                {!loading ? (
                <div className={"ag-theme-quartz"}
                    style={{
                        maxWidth: "calc(100vw - 72px - 40px - 16px)",
                        width: section2width.valueOf() > 8 || section2width === 0 ? "100%" : `${(Number(section2width)+ 1)  *150 + 3}px`,
                        height: "205px",
                      overflowY: "hidden",
                      borderRadius: "0px",
                    }}>
                    <AgGridReact
                      rowData={section2Data}
                      columnDefs={section2ColDefs}
                      rowHeight={32}
                      headerHeight={36}
                      context={{suffixArray: section2Data}}
                      defaultColDef={{
                            width: 150,  // ⬅️ sets all columns to 100px
                            resizable: true, // optional: allow manual resizing
                            cellStyle: { padding: 0, margin: 0 },
                            headerClass: 'ag-header-no-padding'
                        }}
                    /> 
                </div>
                ) : (
                <div className='h-[200px] w-full flex justify-center items-center'>
                    <CircularProgress />
                </div>
                )}
            </div>
        </div>
        ) : ( 
            <div className="w-full p-2" style={{
            boxShadow: "0px 4px 16px 16px rgba(130,130,130,0.05)",
            borderEndStartRadius: "8px",
            borderEndEndRadius: "8px",
            borderTopRightRadius: "8px",
            zIndex: 20
        }}>
            <div
            className="flex h-[40px] px-[6px] py-1 w-fit mb-2 items-start rounded-[4px]"
            style={{
                backgroundColor: "#F9F9FB",
            }}
            >
            {stage_3?.map(name => {
                    return (
                        <div
                        className="flex w-[150px] px-4 py-2 justify-center items-center gap-1 self-stretch rounded-[4px] cursor-pointer"
                        style={{
                            color: product_detail === name
                            ? "#FFF"
                            : "#97979A",
                            backgroundColor: product_detail === name
                            ? "#1565C0"
                            : "#F9F9FB",
                            boxShadow: product_detail === name
                            ? "0px 4px 16px 16px rgba(130,130,130,0.05)"
                            : "none",
                            display: (view_type === "campaign" || view_type === "targeting" || view_type === "cst") && name === "BY ORDERS" ? "none" : "flex",
                        }}
                        onClick={() => {
                            setProduct_detail(name);
                            onChangeStageHandler(view_type, performer, name, metrics);
                            saveLastState(view_type, performer, name, metrics);
                        }}
                        >
                            <div
                                style={{
                                color: product_detail === name
                                    ? "white"
                                    : "#97979A",
                                textAlign: "center",
                                fontFamily: "Inter",
                                fontSize: "10px",
                                fontStyle: "normal",
                                fontWeight: product_detail === name
                                    ? 600
                                    : 500,
                                lineHeight: "10px",
                                letterSpacing: "1.6px",
                                textTransform: "uppercase",
                                }}
                            >
                                {name}
                            </div>
                        </div>)
                })}
            </div>

            <div className="flex flex-col gap-4">
                <div className="flex justify-between items-start gap-4 self-stretch">
                    <div className="flex flex-col justify-center items-start gap-1">
                        <div
                            className="self-stretch"
                            style={{
                            color: "var(--Text-Primary-Black, #1C1C1E)",
                            fontFamily: "Inter",
                            fontSize: "20px",
                            fontStyle: "normal",
                            fontWeight: 700,
                            lineHeight: "26px",
                            textTransform: "uppercase"
                            }}
                        >
                            {subHeaderName}
                        </div>
                        </div>
                    <div className="flex gap-2">
                        <Button
                            color="neutral"
                            sx={{
                            height: 32,
                            width: 80,
                            fontSize: 14,
                            fontWeight: 700,
                            backgroundColor: "#FFF",
                            lineHeight: "20px",
                            color: "#1C1C1E",
                            ":hover": {
                                backgroundColor: "#FFF",
                            },
                            paddingX: "6px",
                            paddingY: 0,
                            gap: "8px",
                            borderRadius: "6px",
                            border: `1px solid #EAEAED`,
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            }}
                            onClick={() => {
                                setMetricsToggle(true);
                            }}
                        >
                            <div
                            style={{
                                fontSize: "12px",
                                fontWeight: "700",
                                textAlign: "center",
                                lineHeight: "18px",
                                color: "#1C1C1E",
                            }}
                            >
                            Metrics & Performers
                            </div>
                        </Button>
                    </div>
                </div>

                {!loading ? (
                <div className={"ag-theme-quartz"}
                    style={{
                        maxWidth: "calc(100vw - 72px - 40px - 16px)",
                        width: section2width.valueOf() > 8 || section2width === 0 ? "100%" : `${(Number(section2width)+ 1)  *150 + 3}px`,
                        height: "205px",
                      overflowY: "hidden",
                      borderRadius: "0px",
                    }}>
                    <AgGridReact
                      rowData={section2Data}
                      columnDefs={section2ColDefs}
                      rowHeight={32}
                      headerHeight={36}
                      context={{suffixArray: section2Data}}
                      defaultColDef={{
                            width: 150,  // ⬅️ sets all columns to 100px
                            resizable: true, // optional: allow manual resizing
                            cellStyle: { padding: 0, margin: 0 },
                            headerClass: 'ag-header-no-padding'
                        }}
                    />
                </div>) : (
                    <div className='h-[200px] w-full flex justify-center items-center'>
                        <CircularProgress />
                    </div>
                )}
            </div>
        </div>
        )}
    </>
  )
}

export default ViewComponent1